
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-raf-scheduler/-embroider-implicit-modules.js";
